// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3BwEg","vLegacy":"SelectSecondary_vLegacy__1qYPa","error":"SelectSecondary_error__3t_0p","disabled":"SelectSecondary_disabled__3zo7s"};